export { renderMessageBarTitle_unstable as renderMessageBarTitle } from '@fluentui/react-message-bar';
